import { useField, Field } from 'formik';
import React from 'react';
import styled, { css } from 'styled-components';
import { useWorkspace } from '~/contexts';
import { useCurrencyFormat } from '~/hooks';
import { colors, weights } from '~/styles';

const MaterialPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0.625rem;
  margin-left: 1px;
  padding: 0 0.25rem;
  color: ${colors.grey40};
  font-size: 0.75rem;
  background-color: ${colors.white};
  border-radius: 0.3125rem;
  transform: translateY(-50%);
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: opacity 100ms;
  pointer-events: none;
`;

const Container = styled.div`
  position: relative;
`;

const Box = styled.div`
  display: flex;
  position: relative;
  min-height: 2.5rem;
  color: ${colors.grey};
  font-size: 1rem;
  border: solid 1px ${colors.grey10};
  background-color: ${colors.grey5};
  border-radius: 0.25rem;
`;

const Value = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 0.25rem;
  background-color: ${colors.grey5};
  padding: 0.625rem 0.75rem 0.375rem 0.875rem;
`;

const Currency = styled.div`
  border-radius: 0.25rem 0 0 0.25rem;
  background-color: ${colors.primary10};
  border-right: 1px solid ${colors.primary25};
  color: ${colors.primary100};
  font-weight: ${weights.medium};

  ${({ hasLabel }) =>
    hasLabel
      ? css`
          padding: 0.625rem 0.75rem 0.375rem 0.75rem;
        `
      : css`
          padding: 0.625rem 0.75rem 0.4375rem 0.75rem;
        `}
`;

function ReadCurrencyTextbox({ label, currency, value }) {
  const materialPlaceholderValue = label;
  const materialAlwaysVisible = true;
  const { workspace } = useWorkspace();

  const currencySymbol = useCurrencyFormat({ locale: workspace.locale, currency: currency || workspace.currency })
    .formatToParts(1)
    .find((part) => part.type === 'currency').value;

  return (
    <Container>
      <Box>
        <Currency hasLabel={!!label}>{currencySymbol}</Currency>
        {value != null && <Value>{value}</Value>}
        {!!materialPlaceholderValue && (
          <MaterialPlaceholder isVisible={materialAlwaysVisible || !!value}>
            {materialPlaceholderValue}
          </MaterialPlaceholder>
        )}
      </Box>
    </Container>
  );
}
function FieldReadCurrencyTextbox(props) {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;

  return (
    <Field.Control error={error}>
      <ReadCurrencyTextbox value={field.value} {...field} {...props} />
    </Field.Control>
  );
}

export default ReadCurrencyTextbox;
export { FieldReadCurrencyTextbox };
